import { formatMoney } from 'accounting'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useCustomItem from '@hooks/useCustomItem'

import type { CustomItemModel } from '@models/types'

interface CustomItemProps {
  customItem: CustomItemModel,
}

const CustomItem = (props: CustomItemProps) => {
  const {
    customItem,
    customItem: {
      description,
      price,
      title,
    },
  } = props

  const { callbacks: { createOrEditCustomItem } } = useCustomItem(customItem)

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditCustomItem()}
      secondaryText={description}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formatMoney(price)}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default CustomItem
